import { render, staticRenderFns } from "./book.vue?vue&type=template&id=1813ba9e&scoped=true"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"
import style0 from "./book.vue?vue&type=style&index=0&id=1813ba9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813ba9e",
  null
  
)

export default component.exports